import {shallowEqual, useSelector} from "react-redux";

export default function useAuth() {
    const {isSuperAgent} = useSelector(({auth}) => ({
        isSuperAgent: auth?.user?.number === process.env.REACT_APP_SUPER_AGENT ?? 301002
    }), shallowEqual);

    return {
        isSuperAgent
    }
}